module.exports = __webpack_public_path__ + "img/g1-4-e.e28bfc6d.png";